import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { createDialog } from '@patsnap/tahiti-core';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type {
    SaveToWorkspaceDialogOptions,
    SaveToWorkspaceDialogResult,
} from '../../components/SaveToWorkspaceDialog.vue';

// Re-export types for external use
export type { SaveToWorkspaceDialogOptions, SaveToWorkspaceDialogResult };

/**
 * SaveToWorkspace 对话框服务工厂
 */
const saveToWorkspaceDialogServiceFactory = createDialog(() => import('../../components/SaveToWorkspaceDialog.vue'));

/**
 * SaveToWorkspace 对话框命令处理器
 */
@injectable()
export class SaveToWorkspaceDialogCommandHandler implements CommandContribution {
    private _dialogService = saveToWorkspaceDialogServiceFactory();

    /**
     * 处理打开 SaveToWorkspace 对话框命令
     */
    private async _handleOpenSaveToWorkspaceDialog(payload?: SaveToWorkspaceDialogOptions): Promise<SaveToWorkspaceDialogResult> {
        return new Promise((resolve) => {
            const dialog = this._dialogService;

            dialog.onSubmit(async (result, next) => {
                console.log('SaveToWorkspace dialog submitted:', result);
                resolve(result);
                next();
            });

            dialog.onCancel(() => {
                const result: SaveToWorkspaceDialogResult = {
                    action: 'close',
                };
                resolve(result);
            });

            dialog.open({
                ...payload,
                width: '992px',
                height: 'auto',
            });
        });
    }

    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'save-to-workspace:open-dialog',
        }, {
            execute: (payload?: SaveToWorkspaceDialogOptions) => {
                return this._handleOpenSaveToWorkspaceDialog(payload);
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开保存到工作空间对话框
         * @param commandId - 命令 ID
         * @param params - 参数
         */
        executeCommand(commandId: 'save-to-workspace:open-dialog', params?: SaveToWorkspaceDialogOptions): Promise<SaveToWorkspaceDialogResult>;
    }
}
